<template>
  <v-card v-if="loading" class="pa-16" style="height: 100vh">
    <h2 class="text-center">
      <v-progress-circular
          class="mr-2"
          color="primary"
          indeterminate
      ></v-progress-circular
      >
      Loading...
    </h2>
  </v-card>
  <v-card v-else class="pa-2" style="min-height: 100vh">
    <v-card class="mb-20 pa-2" elevation="2">
      <v-row>
        <v-col sm="4">
          <v-select
              v-model="typeOfLocation"
              :items="['Accrediators', 'CPD Providers']"
              label="Type of location"
              @input="changePlaceType($event)"
          ></v-select>
        </v-col>
        <v-col v-if="expertLevel == ('FED' || 'REG')" sm="4">
          <v-select
              :items="regions"
              item-text="name"
              item-value="id"
              label="Regions"
              @input="changeRegion($event)"
          ></v-select>
        </v-col>
      </v-row>
      <h2 v-if="typeOfLocation">Here are the lists of {{ typeOfLocation }} registerd within the system</h2>
    </v-card>
    <v-card
        :loading="mapLoading"
        elevation="2"
    >
      <div id="map" class="ma-4"></div>
    </v-card>
  </v-card>
</template>

<script>
import "../../plugins/leaflet/leaflet.css";
import * as L from "leaflet";
import {MapService} from "./map.service";
import {MfrService} from '../Lookups/mfr/mfr.service';

export default {
  name: "MAP",
  components: {},
  data() {
    return {
      loading: false,
      expertLevel:
          localStorage.getItem("user") &&
          JSON.parse(localStorage.getItem("user")).data.expertLevels
              ? JSON.parse(localStorage.getItem("user")).data.expertLevels.code
              : "",
      regions: [],
      typeOfLocation: "",
      mapLoading: false,
    };
  },
  methods: {
    async changePlaceType(event) {
      this.mapLoading = true
      if (event == "Accrediators") {
        let accrediators = await MapService.getAccrediatorsMap();

        this.updateMap(accrediators.data, "Accrediators", 6);
      }
      if (event == "CPD Providers") {
        let cpdProviders = await MapService.getCpdProvidersMap();

        this.updateMap(cpdProviders.data, "CPD Providers", 6);
      }
    },

    async updateMap(locationsList, type, regionZoom) {
      const places = [{name: "Addis Ababa", coords: [9.005401, 38.763611]}];
      const center = places[0].coords;
      const zoom = regionZoom;
      if (L.DomUtil.get("map") !== undefined) {
        L.DomUtil.get("map")._leaflet_id = null;
      }
      const map = L.map("map", {});

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
            'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
      }).addTo(map);

      map.setView(center, zoom);

      const markerOptions = {
        radius: 12,
        stroke: true,
        fill: true,
        fillColor: "#de0000",
        fillOpacity: 0.8,
      };

      locationsList.map((c) =>
          L.circleMarker([+c.latitude, +c.longtiude], markerOptions)
              .addTo(map)
              .bindPopup(
                  type == "Accrediators"
                      ? `<div>
              
                <strong>Name - </strong> 
                ${c.accreditorName}
                  <br>
                  <strong>Accrediated on - </strong>
                  ${c.accreditationDate}
                  <br>
                  <strong>Email - </strong>
                  ${c.institutionalEmail}
                  <br>
                  <strong>Phone - </strong>
                  ${c.institutionalPhone}
                  <br> 
                  <strong>Status - </strong>
                  ${
                          c.isActive == true
                              ? "<span class='activeMarker'>Active</span>"
                              : "<span class='inActiveMarker'>Inactive</span>"
                      }
               
            <br/></div>`
                      : `<div>${c.trainingCenterName}</div>`
              )
      );
      this.mapLoading = false
    },

    async changeRegion(region) {
      this.mapLoading = true
      let locationsList = await MapService.getMapByRegion(
          region,
          this.typeOfLocation
      );
      this.updateMap(
          locationsList ? locationsList.data : [],
          this.typeOfLocation,
          12
      );
    },
  },

  async mounted() {
    const res = await MfrService.getRegionsDrp();
    this.regions = res.data;
  },
};
</script>

<style scoped>
.iCountUp {
  font-size: 1em;
  margin: 0;
  color: #1976d2;
}

#map {
  height: 80vh;
}

</style>
<style>.activeMarker {
  padding: 3px;
  font-weight: bold;
  color: white;
  background: green;
  border-radius: 5px;
}

.inActiveMarker {
  padding: 3px;
  font-weight: bold;
  color: white;
  background: rgb(199, 46, 8);
  border-radius: 5px;
}

.v-menu__content {
  z-index: 9999 !important;
}
</style>